/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Box, TableCell, TableRow } from "@mui/material";
import { Image, Space } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Button, TextField } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import { customAlaphabetValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import { NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import { unitClassHead } from "../../../../../config/constant";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';

export const UnitClassTable = (props) => {
    const [visible, setVisible] = useState(false);
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const { details, rowClick, onRequestSort, sortOrder, sortBy,
        loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const [name, setName] = useState('');
    const [unitClassId, setUnitClassId] = useState('');
    const [errorName, setErrorName] = useState(false);
    const [selectedID, setSelectedID] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false);

    const onEdit = (data) => {
        setVisible(true);
        setName(data.name);
        setUnitClassId(data.id);
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const emptyState = () => {
        setErrorName(false);
    };
    const emptyStateInput = () => {
        setName('');
    };

    const editClass = (e) => {
        e.preventDefault();
        let emptyName = customAlaphabetValidation('Unit Class', name);
        emptyState();
        if (emptyName.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'unitclass',
                title: 'Unit Class',
                id: unitClassId,
                details: {
                    name: name,
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            if (text.includes("name_UNIQUE")) {
                setErrorName('This class is already defined');
            }
        }
    }, [editDetails, editError]);

    const onDelete = (data) => {
        setDeleteModal(true);
        setName(data.name);
        setUnitClassId(data.id);
    }


    const handleRowClick = (value) => {
        setSelectedID(value);
        rowClick(value);
    }

    const classes = customStyles()

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={unitClassHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}
                                                onClick={() => { handleRowClick(data.id) }}
                                                selected={selectedID === data.id}
                                                classes={{ selected: classes.selected }}>
                                                <TableCell style={{ width: getColumnWidth(unitClassHead, 0) }}><span style={{ width: getColumnWidth(unitClassHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell>

                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Unit Class', 'edit', 'Younote Admin') || checkCRUDPermission('Unit Class', 'edit', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Unit Class', 'deletable', 'Younote Admin') || checkCRUDPermission('Unit Class', 'deletable', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                        {'If no Unit Class are Listed here. Please Contact Younote Admin'}
                                                    </p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Unit Class'}
                className={clsx(classes.removeUnderline, classes.closeBackGround)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component='form'
                        autoComplete='off'
                        onSubmit={(e) => editClass(e)}>
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Unit Class Name ", <span key={"Unit Class Name"} className={classes.colorRedRequired}> *</span>]}
                                value={name}
                                variant={'standard'}
                                error={errorName ? true : false}
                                helperText={errorName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="Update"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>
                                    Update & Close
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={unitClassId} loadTasks={() => loadTasks()} name={name} url={'unitclass'} title={'Unit Class'} visible={deleteModal} />
        </>
    )
}